import { ShadowController, SHADOW_DEFAULTS } from './ShadowController.js';
import { IVector3 } from '../../../../api.js';
export class PointLightShadowController extends ShadowController {
    constructor(_light, _babylon_light, _light_system) {
        const shadow_values = SHADOW_DEFAULTS.POINT_LIGHT;
        super(_light, _babylon_light, _light_system, shadow_values.resolution, shadow_values.near, shadow_values.far, _babylon_light.getEngine().webGLVersion === 1 ? shadow_values.webgl1_bias : shadow_values.webgl2_bias);
    }
    should_update_shadowmap(meshes_modifications) {
        // TODO rework to `some`? compare performance
        for (const mod of meshes_modifications) {
            // Checks if the moved object was or is in the bounds of the shadow.
            const light_affects_old_bounds = this.sphere_inside_pointlight_shadow(mod.old_bounds, this._light);
            const light_affects_new_bounds = this.sphere_inside_pointlight_shadow(mod.new_bounds, this._light);
            if (light_affects_old_bounds || light_affects_new_bounds) {
                return true;
            }
        }
        return false;
    }
    sphere_inside_pointlight_shadow(sphere, light) {
        const delta = IVector3.subtract(sphere.position, light.get_world_position());
        const maxc = Math.max(Math.abs(delta.x), Math.abs(delta.y), Math.abs(delta.z));
        // This check will result in some false positives since it doesn't "round" the corners.
        // E.g. an object on on a diagonal from the light might flag the shadowmap as dirty even though it is slightly outside
        // The shadow far plane.
        return maxc < (this.shadow_far + sphere.radius) && maxc > (this.shadow_near - sphere.radius);
    }
}
//# sourceMappingURL=PointLightShadowController.js.map